import LoadingSpinner from 'components/loadingSpinner';
import { CheckoutProvider } from 'features/paymentScreenV2/checkout.context';
import PaymentScreenV2 from 'features/paymentScreenV2/containers/PaymentScreenV2/PaymentScreen';
import { useCheckoutRevampFeatureToggle } from 'hooks/useCheckoutRevampFeatureToggle';
import { useQueryParamValue } from 'hooks/useQueryParamValue';
import lz from 'lz-string';

import PaymentScreen from '../PaymentScreen/PaymentScreen.container';

const PaymentScreenRedirect = () => {
  const configurationParam = useQueryParamValue('c');
  const decompressedConfiguration = configurationParam
    ? lz.decompressFromEncodedURIComponent(configurationParam)
    : undefined;
  const configuration = decompressedConfiguration
    ? JSON.parse(decompressedConfiguration)
    : undefined;

  const displayNewPaymentScreen = useCheckoutRevampFeatureToggle(
    configuration.type
  );

  if (!displayNewPaymentScreen.flagsReady) {
    return <LoadingSpinner />;
  }

  if (configuration && displayNewPaymentScreen.hasCheckoutRevampFlag) {
    return (
      <CheckoutProvider>
        <PaymentScreenV2 />
      </CheckoutProvider>
    );
  }

  return <PaymentScreen />;
};

export default PaymentScreenRedirect;
